import React from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';

const DoNotSell = () => (
  <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5', display: 'flex', flexDirection: 'column' }}>
    <Header />
    <main style={{ padding: '120px 2rem 2rem', maxWidth: 800, margin: '0 auto', width: '100%', boxSizing: 'border-box', flex: 1, textAlign: 'left' }}>
      <h1>Do Not Sell My Personal Information</h1>
      <p>At S. Huntley &amp; Co., we value your privacy. We do not sell your personal information to third parties.</p>
      <p>If you are a California resident, the California Consumer Privacy Act (CCPA) gives you the right to request:</p>
      <ul>
        <li>Disclosure of personal data we have collected</li>
        <li>Deletion of your personal data</li>
        <li>Confirmation that we do not sell your data</li>
      </ul>
      <p>If you would like to make a request under CCPA, please email us at:</p>
      <p><span role="img" aria-label="email">📧</span> <a href="mailto:david@bidderiq.com">david@bidderiq.com</a></p>
    </main>
    <Footer />
  </div>
);

export default DoNotSell;
